import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../../../components/atoms/button";
import Loading from "../../../components/atoms/loading";
import NavBar from "../../../components/organisms/navbar";
import useAuthenticate from "../../../hooks/useAuthenticate";
import api from "../../../services/api";
import { Content, FormContainer, PageDescription, PageTitle, Shake } from "../styles";
import SelectFighters from "../../../components/atoms/selectFighters";
import rulesICopaBjjTalent2026Gi from "../../../data/rules-i-copa-bjj-talent-de-jiu-jitsu-2026-gi.json";
import rulesICopaBjjTalent2026NoGi from "../../../data/rules-i-copa-bjj-talent-de-jiu-jitsu-2026-nogi.json";
import Swal from "sweetalert2";
import NoOptionsAlert from "src/components/atoms/no-options-alert";
import { Stack, Typography, Box, TextField, InputAdornment, Fade, Checkbox, Collapse, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Dialog, DialogTitle, DialogContent, CircularProgress } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import EditFighterModal from "src/components/atoms/editAtleteModal";
import { Label } from "src/components/atoms/input/styles";
import { useKonamiCode } from "src/utils/konamiCode";
import styled from "styled-components";
import FederationVerificationBox from "src/components/organisms/federationVerification";

const StyledFormControlLabel = styled(FormControlLabel)`
  & .MuiFormControlLabel-label {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 0.95rem;
    color: #33303E;
  }
`;

const EnrollmentICopaBjjTalentDeJiuJitsu2026 = () => {
  const haveGuarantee = true;
  const navigate = useNavigate();
  const { getToken, account } = useAuthenticate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    control,
    unregister,
    clearErrors,
    trigger,
    getValues,
  } = useForm({
    shouldUnregister: true,
  });

  const comboValue = 130;
  const giFiled = "valorInscricao";
  const noGiFiled = "valorInscricao";

  const slugGI = "i-copa-bjj-talent-de-jiu-jitsu-manaus-am-gi";
  const slugNOGI = "i-copa-bjj-talent-de-jiu-jitsu-manaus-am-nogi";

  const modalidade = [
    { title: "Não", option: 0 },
    { title: "Sim", option: 1 },
  ];

  let { slug } = useParams();
  let rulesGI = rulesICopaBjjTalent2026Gi;
  let rulesNOGI = rulesICopaBjjTalent2026NoGi;

  const [ages, setAges] = useState<any>([]);
  const [genre, setGenre] = useState<any>([]);
  const [belts, setBelts] = useState<any>([]);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [fighters, setFighters] = useState<any>([]);
  const [tournament, setTournament] = useState<any>({});
  const [enrollmentType, setEnrollmentType] = useState<String>("");
  const [selectedFighter, setSelectedFighter] = useState<any>(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [noCategoriesAvailable, setNoCategoriesAvailable] = useState<boolean>(false);
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight, });
  const [selectedFighterId, setSelectedFighterId] = useState<number | null>(null);
  const handleEditAtlete = () => {
    setIsEditModalOpen(true);
  };
  const [autoCategory, setAutoCategory] = useState<any>([]);
  const [rawWeights, setRawWeights] = useState<any>([]);
  const lastValidGiWeightRef = useRef<string>("");
  const lastValidNOGiWeightRef = useRef<string>("");
  const [shakeTrigger, setShakeTrigger] = useState(0);
  const konami = useKonamiCode();
  const [konamiCategory, setKonamiCategory] = useState<any>("");
  const rePeso = /^\d{0,3}([,.]\d{0,1})?$/;
  const [federationVerified, setFederationVerified] = useState<boolean>(false);
  const [wantsChampionGuarantee, setWantsChampionGuarantee] = useState<boolean | null>(null);
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [guaranteeImageLoaded, setGuaranteeImageLoaded] = useState(false);

  const handleFighterUpdated = (updated: any) => {
    const updatedData = { ...selectedFighter, ...updated };
    const beltChanged = String(updated.belt) !== String(selectedFighter?.belt);
    const genreChanged = updated.genre?.toLowerCase() !== selectedFighter?.genre?.toLowerCase();
    const birthDateChanged = updated.birth_date !== selectedFighter?.birth_date;

    if (selectedFighterId == 0) {
      account.name = updated.name;
    } else {
      setFighters((prev: any) =>
        prev.map((f: any) => (f.id === updated.id ? { ...f, ...updated } : f))
      );
    }
    setSelectedFighter(updatedData);
    setIsEditModalOpen(false);

    if (beltChanged || genreChanged || birthDateChanged) {
      setValue("gi.category", "");
      setValue("gi.weight", "");
      setValue("gi.modalidade", undefined);
      setValue("nogi.category", "");
      setValue("nogi.weight", "");
      setValue("nogi.modalidade", undefined);
      applyFighterLogic(updatedData);
    }
  };

  const formatBirthDate = (d: string | undefined): string => {
    if (!d) return '';
    const cleaned = d.includes('T') ? d.split('T')[0] : d.trim();
    const parts = cleaned.replace(/\//g, '-').split('-');
    if (parts.length !== 3) return d;
    if (parts[0].length === 4) return `${parts[2]}/${parts[1]}/${parts[0]}`;
    return `${parts[0]}/${parts[1]}/${parts[2]}`;
  };

  const fields = tournament.isFederated ? [
    { id: 'gym', label: 'Academia', value: selectedFighter?.gym.toUpperCase() },
    { id: 'belt', label: 'Faixa', value: belts[0]?.title.toUpperCase() || '' },
    { id: 'birthDate', label: 'Data de nascimento', value: formatBirthDate(selectedFighter?.birth_date) },
    { id: 'gender', label: 'Gênero', value: selectedFighter?.genre.toUpperCase() },
  ] : [
    { id: 'gym', label: 'Academia', value: selectedFighter?.gym.toUpperCase() },
    { id: 'belt', label: 'Faixa', value: belts[0]?.title.toUpperCase() || '' },
    { id: 'age', label: 'Idade de luta', value: ages[0]?.option + ' anos' },
    { id: 'gender', label: 'Gênero', value: selectedFighter?.genre.toUpperCase() },
  ];

  const [checkedStates, setCheckedStates] = useState<{ [key: string]: boolean }>(
    fields.reduce((acc, field) => ({ ...acc, [field.id]: false }), {})
  );

  const allChecked = fields.every(field => checkedStates[field.id]);

  const handleCheckChange = (id: string) => {
    setCheckedStates((prev) => {
      const updated = { ...prev };
      const currentIndex = fields.findIndex((f) => f.id === id);
      const newValue = !prev[id];

      updated[id] = newValue;

      if (!newValue) {
        for (let i = currentIndex + 1; i < fields.length; i++) {
          updated[fields[i].id] = false;
        }
      }

      return updated;
    });
  };

  const verifyCanSubscribe = async () => {
    const tournamentGI = (await api.get(`/tournaments/${slugGI}`)).data;

    const tournamentNOGI = (await api.get(`/tournaments/${slugNOGI}`)).data;

    return enrollmentType === "combo"
      ? tournamentGI!.canSubscribe && tournamentNOGI!.canSubscribe
      : enrollmentType === "nogi"
        ? tournamentNOGI!.canSubscribe
        : enrollmentType === "gi"
          ? tournamentGI!.canSubscribe
          : false;
  };

  const getTitleByOption = (array: any[], option: number) => {
    for (let i = 0; i < array.length; i++) {
      if (array[i].option === +option) {
        return array[i].title;
      }
    }
    return null;
  };

  const onSubmit = async (data: any) => {
    if (tournament.isFederated && !federationVerified) {
      Swal.fire({
        title: "Filiação obrigatória",
        text: "Este torneio exige filiação ativa. Verifique o CPF do atleta antes de continuar.",
        icon: "warning",
      });
      return;
    }

    console.log(data)

    const canSubscribe = await verifyCanSubscribe();
    if (!canSubscribe) {
      const msg = "Período de inscrição encerrado.";

      Swal.fire({
        title: "Atenção!",
        text: msg,
        icon: "error",
      });

      toast.error(msg);
      return;
    }

    setDisabled(true);
    setLoading(true);

    // Dados de filiação para torneios federados — só envia quando há verificação válida
    const federationFields =
      tournament.isFederated && data.affiliationId
        ? {
            affiliationId: data.affiliationId,
            affiliationFederationSlug: data.affiliationFederationSlug || tournament.federationSlug,
          }
        : {};

    const enrollmentIds: number[] = [];

    const arrBelts = [
      { title: "branca", option: 1 },
      { title: "cinza", option: 2 },
      { title: "amarela", option: 3 },
      { title: "laranja", option: 4 },
      { title: "verde", option: 5 },
      { title: "azul", option: 6 },
      { title: "roxa", option: 7 },
      { title: "marrom", option: 8 },
      { title: "preta", option: 9 },
    ];

    data.belt = getTitleByOption(arrBelts, data.belt);
    data.age = data.age.toString();
    delete data.fightingAge;

    if (wantsChampionGuarantee) {
      data.championGuarantee = wantsChampionGuarantee;
    }

    if (enrollmentType === "gi" || enrollmentType === "combo") {
      const category =
        +data.gimodalidade === 1
          ? "pcd - " + autoCategory.item
          : +data.gimodalidade === 0
            ? autoCategory.item
            : "";


      console.log(data);

      const valueSubscription = rulesGI.filter(
        (r) =>
          r.idade.min <= data.age &&
          r.idade.max >= data.age &&
          r.genero === data.genre &&
          r.faixa.some((f: any) => f.nome === data.belt) &&
          r.peso.descricao === data.gi.weight.peso &&
          r.categoria === autoCategory.item
      )[0];

      slug = "i-copa-bjj-talent-de-jiu-jitsu-manaus-am-gi";

      try {
        const dataEnrollment = await api.post(
          `${"/tournaments/enrollment/" + slug}`,
          {
            age: data.age,
            belt: data.belt,
            genre: data.genre,
            weight: `${data.gi.inputWeightKg} kg; ${data.gi.weight.peso}`,
            category: category,
            fightersId: +data.fightersId,
            valueSubscription:
              enrollmentType === "combo"
                ? String(comboValue / 2)
                : String(valueSubscription[giFiled]),
            combo_subscription: enrollmentType === "combo" ? "GI" : null,
            championGuarantee: data?.championGuarantee,
            ...federationFields,
          },
          {
            headers: {
              Authorization: `Bearer ${getToken()}`,
            },
          }
        );

        enrollmentIds.push(dataEnrollment.data.id);
      } catch (error: any) {
        console.log(error);
        setLoading(false);
        Swal.fire({
          title: "Atenção!",
          text: error?.response?.data?.message || "Erro ao processar a inscrição.",
          icon: "error",
        });
        toast.error(
          error?.response?.data?.message ||
          "Não foi possível gerar a sua pré-inscrição!"
        );
        return;
      }
    }

    if (enrollmentType === "nogi" || enrollmentType === "combo") {
      const category =
        +data.nogimodalidade === 1
          ? "pcd - " + autoCategory.item
          : +data.nogimodalidade === 0
            ? autoCategory.item
            : "";

      const valueSubscription = rulesNOGI.filter(
        (r) =>
          r.idade.min <= data.age &&
          r.idade.max >= data.age &&
          r.genero === data.genre &&
          r.faixa.some((f: any) => f.nome === data.belt) &&
          r.peso.descricao === data.nogi.weight.peso &&
          r.categoria === autoCategory.item
      )[0];

      slug = "i-copa-bjj-talent-de-jiu-jitsu-manaus-am-nogi";

      try {
        const dataEnrollment = await api.post(
          `${"/tournaments/enrollment/" + slug}`,
          {
            age: data.age,
            belt: data.belt,
            genre: data.genre,
            weight: `${data.nogi.inputWeightKg} kg; ${data.nogi.weight.peso}`,
            category: category,
            fightersId: +data.fightersId,
            valueSubscription:
              enrollmentType === "combo"
                ? String(comboValue / 2)
                : String(valueSubscription[noGiFiled]),
            combo_subscription: enrollmentType === "combo" ? "NOGI" : null,
            championGuarantee: data?.championGuarantee,
            ...federationFields,
          },
          {
            headers: {
              Authorization: `Bearer ${getToken()}`,
            },
          }
        );

        enrollmentIds.push(dataEnrollment.data.id);
      } catch (error: any) {
        console.log(error);
        setLoading(false);
        Swal.fire({
          title: "Atenção!",
          text: error?.response?.data?.message || "Erro ao processar a inscrição.",
          icon: "error",
        });
        toast.error(
          error?.response?.data?.message ||
          "Não foi possível gerar a sua pré-inscrição!"
        );
        return;
      }
    }

    if (tournament.paymentManual) {
      toast.success("A sua pre-inscrição foi realizada com sucesso!");

      setTimeout(() => {
        navigate(
          "/payment-instruction/" +
          slug +
          "/" +
          enrollmentIds.toString().replace(",", "-")
        );
      }, 2000);

      return;
    }

    api
      .post(
        "/payments/checkout",
        {
          enrollmentId: enrollmentIds,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      )
      .then((res: any) => {
        toast.success("A sua pre-inscrição foi realizada com sucesso!");
        const width = 800;
        const height = 600;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;

        if (windowSize.width < width) {
          window.open(res.data.links[1].href, "_self");
        } else {
          window.open(res.data.links[1].href, "_self");
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(
          error?.response?.data?.message ||
          "Não foi possível gerar a sua pré-inscrição!"
        );
      });
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    api
      .get("/fighters", {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then(({ data }) => {
        setLoading(false);
        setFighters([
          { id: "", name: "Selecione uma opção" },
          { id: 0, name: account.name },
          ...data,
        ]);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Não foi carregar os dados.");
      });

    api.get("tournaments/" + slug).then(({ data }) => {
      setTournament(data);
    });
  }, [account.name]);


  let arrWeights: any = [];
  let acc: any = account;
  let fightingAge: Number;
  let formattedGenre: String;

  const applyFighterLogic = async (fighter: any) => {

    let arrCategories: any = [];
    let arrCategoriesNOGI: any = [];
    let genre: any = [];
    let belts: any = [];

    const arrGenre = [
      { title: "Masculino", option: "masculino" },
      { title: "Feminino", option: "feminino" },
    ];

    const arrBelts = [
      { title: "Branca", option: 1 },
      { title: "Cinza", option: 2 },
      { title: "Amarela", option: 3 },
      { title: "Laranja", option: 4 },
      { title: "Verde", option: 5 },
      { title: "Azul", option: 6 },
      { title: "Roxa", option: 7 },
      { title: "Marrom", option: 8 },
      { title: "Preta", option: 9 },
    ];

    //============================== Genero ==============================
    genre = arrGenre.filter(
      (t) => t.option.toLowerCase() === fighter.genre.toLowerCase()
    );

    formattedGenre = genre[0]?.option.toLowerCase();
    //============================== Idade ==============================

    const dateOfTournament = new Date().getFullYear();
    const birthFightFromFighter = +fighter.birth_date
      .replace(/\//g, "-")
      .split("-")[2];
    fightingAge = dateOfTournament - birthFightFromFighter;
    setAges([{ title: fightingAge, option: fightingAge }]);

    //============================== Faixa ==============================
    belts = arrBelts.filter((b) => b.option === fighter.belt);
    setBelts(belts);

    //============================== Categoria ==============================
    rulesGI.map((item) => {
      if (
        item.idade.max >= +fightingAge &&
        item.idade.min <= +fightingAge &&
        item.genero === formattedGenre &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
        ).length
      ) {
        arrCategories.push({
          item: item.categoria,
          min: item.idade.min,
          max: item.idade.max,
          maxDescricao: item.idade.maxParaDescricao,
          minDescricao: item.idade.minParaDescricao,
          descricaoCompleta: item.idade.descricaoCompleta,
        });
      }
    });

    setAutoCategory(arrCategories[arrCategories.length - 1]);

    rulesNOGI.map((item) => {
      if (
        item.idade.max >= +fightingAge &&
        item.idade.min <= +fightingAge &&
        item.genero === formattedGenre &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
        ).length
      ) {
        arrCategoriesNOGI.push({
          item: item.categoria,
          min: item.idade.min,
          max: item.idade.max,
          maxDescricao: item.idade.maxParaDescricao,
          minDescricao: item.idade.minParaDescricao,
          descricaoCompleta: item.idade.descricaoCompleta,
        });
      }
    });

    // Verificar se há categorias disponíveis
    if (arrCategories.length === 0 || arrCategoriesNOGI.length === 0) {
      setNoCategoriesAvailable(true);
      toast.warning("Não há categorias disponíveis para este atleta com base nos filtros aplicados.");
    }

    const ultimaCategoria = arrCategories[arrCategories.length - 1];

    if (ultimaCategoria) {
      handleChangeWeights({
        target: { value: ultimaCategoria.item },
        idade: fightingAge,
        genero: formattedGenre,
        faixa: belts[0]?.title,
      });
    }

    setGenre([...genre]);
    setBelts([...belts]);
    setValue("genre", genre[0]?.option);
    setValue("age", fightingAge);
    setValue("belt", belts[0]?.option);
    setValue("category", "");
    setSelectedFighter(fighter);

  }

  const handleChange = (e: any) => {
    // RESETAR VERIFICAÇÃO DE FEDERAÇÃO
    setFederationVerified(false);
    setValue("affiliationId", undefined);
    setValue("affiliationFederationSlug", undefined);

    setValue("gi.inputWeightKg", "");
    setValue("gi.weight.peso", "");
    setValue("nogi.weight.peso", "");
    setValue("nogi.inputWeightKg", "");
    setValue("category", "");
    setValue("weight", "");
    setValue("modalidade", "");
    setNoCategoriesAvailable(false);
    setEnrollmentType("")

    // RESETAR OS CHECKS COM APÓS MUDANÇA
    const resetStates = fields.reduce((acc, field) => {
      acc[field.id] = false;
      return acc;
    }, {} as { [key: string]: boolean });

    setCheckedStates(resetStates);

    const id = +e.target.value;
    setSelectedFighterId(id);

    if (id == 0) {
      applyFighterLogic(acc)
    } else {
      const fighter = fighters.find((f: any) => +f.id === id)!;
      applyFighterLogic(fighter)
    };
  }
  //============================== Peso ==============================
  const handleChangeWeights = (e: any) => {

    const idadeRef = e.idade ?? ages[0]?.option;
    const generoRef = e.genero ?? genre[0]?.title.toLowerCase();
    const faixaRef = e.faixa ?? belts[0]?.title;
    setValue("gi.modalidade", "");
    setValue("gi.weight", "");

    rulesGI.map((item) => {
      if (
        item.idade.max >= idadeRef &&
        item.idade.min <= idadeRef &&
        item.genero === generoRef.toLowerCase() &&
        item.categoria === e.target.value &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === faixaRef.toLowerCase()
        ).length
      ) {
        arrWeights.push({
          peso: item.peso.descricao,
          massa: item.peso.max,
        });
      }
    });

    setRawWeights(arrWeights);

    console.log(arrWeights);

  }

  // Aceita massa como: "até 44,3 kg", "até 44.3 kg", "acima de 100 kg", "de 70 a 74,9 kg"
  function encontrarCategoria(valor: number) {
    if (!Array.isArray(rawWeights) || rawWeights.length === 0) {
      return { peso: undefined, massa: undefined, limite: Infinity };
    }

    // por padrão, assume a última categoria (ex.: pesadíssimo)
    let selecionada = rawWeights[rawWeights.length - 1];
    let limite = Infinity;

    // helper: extrai números aceitando "," ou "."
    const extrairNumeros = (s: string): number[] => {
      const matches = s.match(/(\d+(?:[.,]\d+)?)/g) || [];
      return matches.map((m) => parseFloat(m.replace(",", ".")));
    };

    for (const cat of rawWeights) {
      const massa = String(cat?.massa || "").toLowerCase().trim();
      if (!massa) continue;

      const nums = extrairNumeros(massa);
      if (nums.length === 0) continue;

      // 1) "até X"
      if (massa.includes("até")) {
        const max = nums[nums.length - 1];
        if (valor <= max) {
          selecionada = cat;
          limite = max;
          break;
        }
        continue;
      }

      // 2) "acima de X" / "maior que X"
      if (massa.includes("acima") || massa.includes("maior")) {
        const min = nums[nums.length - 1];
        if (valor >= min) {
          selecionada = cat;
          limite = Infinity;
          break;
        }
        continue;
      }

      // 3) "de X a Y" / "entre X e Y"
      if (massa.includes("de") && (massa.includes("a ") || massa.includes(" e "))) {
        const [min, max] = nums.length >= 2 ? [nums[0], nums[1]] : [nums[0], nums[0]];
        if (valor >= min && valor <= max) {
          selecionada = cat;
          limite = max;
          break;
        }
        continue;
      }

      // fallback: se vier só um número sem palavras-chave, trata como "até X"
      if (nums.length === 1) {
        const max = nums[0];
        if (valor <= max) {
          selecionada = cat;
          limite = max;
          break;
        }
      }
    }

    return { ...selecionada, limite };
  }

  const includesGI = enrollmentType === "gi" || enrollmentType === "combo";
  const includesNOGI = enrollmentType === "nogi" || enrollmentType === "combo";

  useEffect(() => {
    if (!includesGI) {
      unregister(["gi.inputWeightKg", "gi.weight", "gimodalidade"]);
      clearErrors(["gi.inputWeightKg", "gi.weight", "gimodalidade"]);
    }
    if (!includesNOGI) {
      unregister(["nogi.inputWeightKg", "nogi.weight", "nogimodalidade"]);
      clearErrors(["nogi.inputWeightKg", "nogi.weight", "nogimodalidade"]);
    }
  }, [enrollmentType, includesGI, includesNOGI, unregister, clearErrors]);



  if (loading)
    return <Loading text="Aguarde, estamos processando a sua pré-inscrição." />;
  return (
    <div>
      <NavBar />

      <Content>
        <FormContainer onSubmit={handleSubmit(onSubmit, () => {
          setShakeTrigger(prev => prev + 1);
        })}>
          <PageTitle>Inscrição</PageTitle>
          <PageDescription>
            Essa inscrição é referente ao torneio: I COPA BJJ TALENT GI E NOGI 2026
          </PageDescription>

          <SelectFighters
            label="Escolha um atleta para esse evento"
            name="fightersId"
            register={register}
            hasError={!!errors.category}
            required
            error="Este campo é obrigatório"
            options={fighters}
            onChange={handleChange}
          />

          {tournament.isFederated && tournament.federationSlug && selectedFighter && (
            <Box sx={{ mt: 2, mb: 1 }}>
              <FederationVerificationBox
                federationSlug={tournament.federationSlug}
                federationName={tournament.federationName || tournament.federationSlug?.toUpperCase()}
                fighterId={selectedFighterId === 0 ? undefined : selectedFighter?.id}
                fighterCpf={selectedFighterId === 0 ? account.cpf : selectedFighter?.cpf}
                fighterBelt={selectedFighter?.belt}
                fighterGym={selectedFighter?.gym}
                isDependentAthlete={selectedFighterId !== 0}
                token={getToken()}
                onVerified={(data) => {
                  setFederationVerified(true);
                  setValue("affiliationId", data.affiliationId);
                  setValue("affiliationFederationSlug", tournament.federationSlug);
                }}
                onNotFound={() => {
                  setFederationVerified(false);
                }}
                onSyncData={async (updates: { belt?: number; gym?: string; genre?: string }) => {
                  try {
                    if (selectedFighterId === 0) {
                      await api.put("/me", updates, {
                        headers: { Authorization: `Bearer ${getToken()}` },
                      });
                    } else {
                      await api.put(`/fighters/${selectedFighter.id}`, {
                        name: selectedFighter.name,
                        mother_name: selectedFighter.mother_name || "nao informado",
                        birth_date: selectedFighter.birth_date,
                        belt: updates.belt ?? selectedFighter.belt,
                        genre: updates.genre ?? selectedFighter.genre,
                        gym: updates.gym ?? selectedFighter.gym,
                        phone: selectedFighter.phone || "",
                      }, {
                        headers: { Authorization: `Bearer ${getToken()}` },
                      });
                      setFighters((prev: any) =>
                        prev.map((f: any) => f.id === selectedFighter.id ? { ...f, ...updates } : f)
                      );
                    }

                    const updatedFighter = { ...selectedFighter, ...updates };
                    setSelectedFighter(updatedFighter);
                    applyFighterLogic(updatedFighter);

                    setCheckedStates(
                      fields.reduce((acc, field) => ({ ...acc, [field.id]: false }), {} as { [key: string]: boolean })
                    );
                    setEnrollmentType("");
                  } catch (err: any) {
                    console.error("Erro ao sincronizar dados:", err);
                    toast.error(err?.response?.data?.message || "Erro ao atualizar dados. Tente novamente.");
                    throw err;
                  }
                }}
                disabled={!selectedFighter}
                athleteName={selectedFighter?.name || account.name || ""}
                athleteEmail={account.email || ""}
                athletePhone={selectedFighter?.phone || account.phone || ""}
                athleteBirthDate={selectedFighter?.birth_date || account.birth_date || ""}
                onCpfUpdated={async (newCpf: string) => {
                  const endpoint = selectedFighterId === 0 ? "/me" : `/fighters/${selectedFighter.id}`;
                  await api.put(endpoint, {
                    ...(selectedFighterId !== 0 && {
                      name: selectedFighter.name,
                      mother_name: selectedFighter.mother_name || "nao informado",
                      birth_date: selectedFighter.birth_date,
                      belt: selectedFighter.belt,
                      genre: selectedFighter.genre,
                      gym: selectedFighter.gym,
                      phone: selectedFighter.phone || "",
                    }),
                    cpf: newCpf,
                  }, {
                    headers: { Authorization: `Bearer ${getToken()}` },
                  });
                  const updated = { ...selectedFighter, cpf: newCpf };
                  setSelectedFighter(updated);
                  if (selectedFighterId !== 0) {
                    setFighters((prev: any) =>
                      prev.map((f: any) => f.id === selectedFighter.id ? { ...f, cpf: newCpf } : f)
                    );
                  }
                }}
                accountName={account.name || ""}
                accountCpf={account.cpf || ""}
                accountPhone={account.phone || ""}
                accountEmail={account.email || ""}
              />
            </Box>
          )}

          {selectedFighter && (!tournament.isFederated || federationVerified) && (
            <Fade in={!!selectedFighter && (!tournament.isFederated || federationVerified)} timeout={800} unmountOnExit>
              <Box
                sx={{
                  border: '1px solid black',
                  borderRadius: 2,
                  padding: '8px 12px',
                  mt: 1,
                  position: 'relative',
                  backgroundColor: '#fefefe',
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography
                    component="span"
                    variant="h6"
                    sx={{ display: 'block' }}
                  >
                    Confirme seus dados:
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                  }}
                >

                  <Stack spacing={1} sx={{ m: 0, p: 0 }}>
                    {(() => {
                      const firstUncheckedIndex = fields.findIndex((field, index) => {
                        const previousChecked = index === 0 || checkedStates[fields[index - 1].id];
                        return previousChecked && !checkedStates[field.id];
                      });
                      return fields.map((field, index) => {
                        const isFirst = index === 0;
                        const previousChecked = isFirst || checkedStates[fields[index - 1].id];
                        const isCurrentChecked = checkedStates[field.id];
                        const shouldShowEditIcon = index === firstUncheckedIndex;

                        return (
                          <Box
                            key={field.id}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              opacity: previousChecked ? 1 : 0.4,
                              pointerEvents: previousChecked ? 'auto' : 'none',
                              transition: 'opacity 0.2s',
                            }}
                          >
                            <Checkbox
                              checked={isCurrentChecked}
                              onChange={() => handleCheckChange(field.id)}
                              color="primary"
                            />

                            <Label>
                              {field.label}:{' '}
                            </Label>

                            <Box
                              component="span"
                              sx={{
                                color: isCurrentChecked ? 'success.main' : 'error.main',
                                fontWeight: 500,
                                fontSize: 'inherit',
                                fontFamily: 'Inter, sans-serif',
                                ml: 1,
                              }}
                            >
                              {field.value}
                            </Box>

                            {shouldShowEditIcon && (
                              <Box
                                onClick={handleEditAtlete}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  ml: 1.5,
                                  cursor: 'pointer',
                                  color: 'text.secondary',
                                  transition: 'color 0.2s',
                                  '&:hover': { color: 'black' },
                                }}
                              >
                                <Typography variant="body2" sx={{ mr: 0.5 }}>
                                  Editar
                                </Typography>
                                <EditIcon sx={{ fontSize: '1.2rem' }} />
                              </Box>
                            )}
                          </Box>
                        );
                      });
                    })()}
                  </Stack>
                </Box>
              </Box>
            </Fade>
          )}

          <br />

          <NoOptionsAlert
            show={noCategoriesAvailable && !!selectedFighter && allChecked}
            type="categories"
            fighterData={{
              name: selectedFighter?.name || "",
              age: ages[0]?.option,
              gender: genre[0]?.title,
              belt: belts[0]?.title,
            }}
          />

          <br />
          <Collapse in={allChecked} timeout={800} unmountOnExit>
            <Box>
              {allChecked && !noCategoriesAvailable && (
                <>
                  <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label" style={{ color: "#33303E" }}>
                      Tipo da Inscrição
                    </FormLabel>
                    <RadioGroup
                      aria-label="Filtrar por"
                      value={enrollmentType}
                      onChange={(e: any) => {
                        setEnrollmentType(e.target.value);
                        setValue("gi.inputWeightKg", "");
                        setValue("gi.modalidade", undefined);
                        setValue("gi.weight.peso", "");
                        setValue("nogi.inputWeightKg", "");
                        setValue("nogi.modalidade", undefined);
                        setValue("nogi.weight.peso", "");
                      }}
                      row
                    >
                      <FormControlLabel value="gi" control={<Radio />} label="GI" />
                      <FormControlLabel value="nogi" control={<Radio />} label="NOGI" />
                      <FormControlLabel value="combo" control={<Radio />} label="COMBO (GI + NOGI)" />
                    </RadioGroup>
                  </FormControl>

                  <Collapse in={enrollmentType === "gi" || enrollmentType === "combo"} timeout={800} unmountOnExit>
                    {(enrollmentType === "gi" || enrollmentType === "combo") && (
                      <>
                        <PageTitle>GI</PageTitle>

                        <Controller
                          name="gi.inputWeightKg"
                          control={control}
                          rules={{ required: "Informe seu peso." }}
                          render={({ field, fieldState }) => (
                            <TextField
                              key={`gi-inputWeightKg-${shakeTrigger}`}
                              {...field}
                              label="Seu peso (kg)"
                              type="text"
                              variant="outlined"
                              fullWidth
                              placeholder="0,0"
                              error={!!fieldState.error}
                              helperText={fieldState.error?.message}
                              sx={{
                                animation: fieldState.error ? `${Shake} 0.3s ease-in-out` : "none",
                              }}
                              onChange={(e) => {
                                let raw = e.target.value.replace(/\D/g, "");
                                if (raw.length > 4) raw = raw.slice(0, 4);

                                if (raw === "") {
                                  field.onChange("");
                                  setValue("gi.weight", "");
                                  lastValidGiWeightRef.current = "";
                                  return;
                                }

                                let formatted = "";
                                if (raw.length === 1) {
                                  formatted = `0,${raw}`;
                                } else {
                                  const intPart = raw.slice(0, -1);
                                  const decimal = raw.slice(-1);
                                  formatted = `${parseInt(intPart, 10)},${decimal}`;
                                }

                                const parsed = Number(formatted.replace(",", "."));
                                if (parsed > 999.9) {
                                  formatted = "999,9";
                                }

                                field.onChange(formatted);
                                lastValidGiWeightRef.current = formatted;

                                if (Number.isFinite(parsed)) {
                                  const categoria = encontrarCategoria(parsed);
                                  setKonamiCategory(categoria.peso);
                                  setValue("gi.weight", categoria || "");
                                } else {
                                  setValue("gi.weight", "");
                                }
                              }}
                              InputProps={{
                                endAdornment: <InputAdornment position="end">kg</InputAdornment>,
                                inputMode: "numeric",
                              }}
                            />
                          )}
                        />

                        {konami && (
                          <Typography variant="body2" sx={{ mt: 1, color: "green" }}>
                            Categoria detectada: {konamiCategory?.toUpperCase()}
                          </Typography>
                        )}

                        <Controller
                          name="gimodalidade"
                          control={control}
                          rules={includesGI ? { required: "Selecione uma modalidade." } : undefined}
                          render={({ field, fieldState }) => (
                            <FormControl
                              component="fieldset"
                              style={{ marginTop: 16 }}
                              error={!!fieldState.error}
                              key={`gimodalidade-${shakeTrigger}`}
                              sx={{
                                animation: fieldState.error ? `${Shake} 0.3s ease-in-out` : "none",
                              }}
                            >
                              <FormLabel component="legend" style={{ color: "#33303E" }}>
                                Pessoa com deficiência - PcD?
                              </FormLabel>

                              <RadioGroup
                                row
                                aria-label="PcD"
                                value={field.value ?? ""}
                                onChange={(e) => field.onChange(e.target.value)}
                              >
                                {modalidade.map((m) => (
                                  <FormControlLabel
                                    key={m.option}
                                    value={String(m.option)}
                                    control={<Radio color="error" />}
                                    label={m.title}
                                  />
                                ))}
                              </RadioGroup>

                              <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                                {fieldState.error?.message}
                              </Typography>
                              <br />
                            </FormControl>
                          )}
                        />
                      </>
                    )}
                  </Collapse>

                  <Collapse in={enrollmentType === "nogi" || enrollmentType === "combo"} timeout={800} unmountOnExit>
                    {(enrollmentType === "nogi" || enrollmentType === "combo") && (
                      <>
                        <PageTitle>NOGI</PageTitle>

                        <Controller
                          name="nogi.inputWeightKg"
                          control={control}
                          rules={{ required: "Informe seu peso." }}
                          render={({ field, fieldState }) => (
                            <TextField
                              key={`nogi-inputWeightKg-${shakeTrigger}`}
                              {...field}
                              label="Seu peso (kg)"
                              type="text"
                              variant="outlined"
                              fullWidth
                              placeholder="0,0"
                              error={!!fieldState.error}
                              helperText={fieldState.error?.message}
                              sx={{
                                animation: fieldState.error ? `${Shake} 0.3s ease-in-out` : "none",
                              }}
                              onChange={(e) => {
                                let raw = e.target.value.replace(/\D/g, "");
                                if (raw.length > 4) raw = raw.slice(0, 4);

                                if (raw === "") {
                                  field.onChange("");
                                  setValue("nogi.weight", "");
                                  lastValidNOGiWeightRef.current = "";
                                  return;
                                }

                                let formatted = "";
                                if (raw.length === 1) {
                                  formatted = `0,${raw}`;
                                } else {
                                  const intPart = raw.slice(0, -1);
                                  const decimal = raw.slice(-1);
                                  formatted = `${parseInt(intPart, 10)},${decimal}`;
                                }

                                const parsed = Number(formatted.replace(",", "."));
                                if (parsed > 999.9) {
                                  formatted = "999,9";
                                }

                                field.onChange(formatted);
                                lastValidNOGiWeightRef.current = formatted;

                                if (Number.isFinite(parsed)) {
                                  const categoria = encontrarCategoria(parsed);
                                  setValue("nogi.weight", categoria || "");
                                } else {
                                  setValue("nogi.weight", "");
                                }
                              }}
                              InputProps={{
                                endAdornment: <InputAdornment position="end">kg</InputAdornment>,
                                inputMode: "numeric",
                              }}
                            />
                          )}
                        />

                        {konami && (
                          <Typography variant="body2" sx={{ mt: 1, color: "green" }}>
                            Categoria detectada: {konamiCategory?.toUpperCase()}
                          </Typography>
                        )}

                        <Controller
                          name="nogimodalidade"
                          control={control}
                          rules={includesNOGI ? { required: "Selecione uma modalidade." } : undefined}
                          render={({ field, fieldState }) => (
                            <FormControl
                              component="fieldset"
                              style={{ marginTop: 16 }}
                              error={!!fieldState.error}
                              key={`nogimodalidade-${shakeTrigger}`}
                              sx={{
                                animation: fieldState.error ? `${Shake} 0.3s ease-in-out` : "none",
                              }}
                            >
                              <FormLabel component="legend" style={{ color: "#33303E" }}>
                                Pessoa com deficiência - PcD?
                              </FormLabel>

                              <RadioGroup
                                row
                                aria-label="PcD"
                                value={field.value ?? ""}
                                onChange={(e) => field.onChange(e.target.value)}
                              >
                                {modalidade.map((m) => (
                                  <FormControlLabel
                                    key={m.option}
                                    value={String(m.option)}
                                    control={<Radio color="error" />}
                                    label={m.title}
                                  />
                                ))}
                              </RadioGroup>

                              <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                                {fieldState.error?.message}
                              </Typography>
                              <br />
                            </FormControl>
                          )}
                        />
                      </>
                    )}
                  </Collapse>
                </>
              )}
            </Box>
          </Collapse>

          {selectedFighter && allChecked && enrollmentType && haveGuarantee && (
            <Controller
              name="wantsGuarantee"
              control={control}
              rules={{
                validate: (value) =>
                  value === true || value === false ? true : "Selecione uma opção."
              }}
              render={({ field, fieldState }) => (
                <FormControl component="fieldset" error={!!fieldState.error} sx={{ mt: 2 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                    <FormLabel component="legend" style={{ color: "#33303E", fontFamily: 'inter, sans-serif' }}>
                      Deseja incluir a garantia campeã?
                    </FormLabel>
                    <InfoOutlineIcon
                      onClick={() => setInfoModalOpen(true)}
                      sx={{ cursor: 'pointer' }}
                    />
                  </Box>

                  <RadioGroup
                    row
                    value={
                      wantsChampionGuarantee === null
                        ? ""
                        : wantsChampionGuarantee
                          ? "sim"
                          : "nao"
                    }
                    onChange={(e) => {
                      const value = e.target.value === "sim";
                      field.onChange(value);
                      setWantsChampionGuarantee(value);

                      if (value === true) {
                        setInfoModalOpen(true);
                      }
                    }}
                  >
                    <StyledFormControlLabel value="sim" control={<Radio />} label="Sim" />
                    <StyledFormControlLabel value="nao" control={<Radio />} label="Não" />
                  </RadioGroup>

                  <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                    {fieldState.error?.message}
                  </Typography>
                </FormControl>
              )}
            />
          )}

          {selectedFighter && allChecked && enrollmentType && (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button type="submit" label="Inscrever" disabled={disabled} />
            </Box>
          )}

        </FormContainer>

        <Dialog open={infoModalOpen} onClose={() => setInfoModalOpen(false)}>
          <DialogTitle>O que é a Garantia Campeã?</DialogTitle>
          <DialogContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: 380,
                mb: 2,
                position: "relative",
              }}
            >
              {!guaranteeImageLoaded && <CircularProgress size={28} sx={{ position: "absolute", color: "black" }} />}

              <Fade in={guaranteeImageLoaded} timeout={700}>
                <img
                  src="/icons/garantia2.png"
                  alt="garantia campeã"
                  style={{
                    maxWidth: "400px",
                    maxHeight: "380px",
                    objectFit: "contain",
                    display: "block",
                  }}
                  onLoad={() => setGuaranteeImageLoaded(true)}
                  onError={() => setGuaranteeImageLoaded(false)}
                />
              </Fade>
            </Box>

            <Typography
              variant="body1"
              sx={{ textAlign: "center", fontWeight: "bold" }}
            >
              Garanta já a sua adesão à GARANTIA CAMPEÃ e assegure o reembolso de 80% do
              valor da inscrição (excluindo produtos), em situações de lesão e/ou
              acidente. O benefício será concedido mediante contato e apresentação de
              laudo médico, até a segunda-feira que antecede o início do evento.
            </Typography>

            <Typography
              variant="body1"
              sx={{ textAlign: "left", fontWeight: "bold", color: "green", mt: 2 }}
            >
              Valor: R$ 5,00
            </Typography>
          </DialogContent>
        </Dialog>

        {isEditModalOpen && (
          <EditFighterModal
            targetValue={selectedFighterId}
            fighter={selectedFighter}
            onUpdated={handleFighterUpdated}
            open={true}
            onClose={() => setIsEditModalOpen(false)}
            isFederated={tournament.isFederated && federationVerified}
            federationSlug={tournament.federationSlug}
            federationName={tournament.federationName || tournament.federationSlug?.toUpperCase()}
            affiliationId={getValues("affiliationId")}
          />
        )}

      </Content>
    </div>
  );
};

export default EnrollmentICopaBjjTalentDeJiuJitsu2026;
